import type { SeoSegments } from '@handyhand/i18n';
import { Tip } from '@models/guides/tips.model';
import { buildContentPath, contentSlug } from '@helpers/contentPath';

export function flattenTipGroups(
  groups: ReadonlyArray<{ tips?: Tip[] } | null | undefined> | null | undefined,
): Tip[] {
  const all = (groups ?? []).flatMap((group) => group?.tips ?? []);
  return [...all].sort(
    (first, second) => (second.viewCount || 0) - (first.viewCount || 0),
  );
}

export function tipPath(
  tip: Tip,
  seoSegments: Pick<SeoSegments, 'suffix'>,
  visitedCategories: ReadonlyArray<string | null | undefined>,
): string {
  if (tip.path) {
    return tip.path;
  }
  return buildContentPath({
    categories: visitedCategories.slice(0, 2),
    slug: contentSlug(tip),
    suffix: seoSegments.suffix.tips,
  });
}
